module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metasasha/metabase/releases/18-11-2022/44.5/metabase/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metasasha/metabase/releases/18-11-2022/44.5/metabase/frontend/src/metabase/lib/ga-metadata.js"));
    });
  });
}